export const NFT_OF_THE_DAY_MOCK = [
  {
    asset: {
      name: 'Morocco',
      token_id: '1285',
      id: 1050,
      description: 'Morocco',
      country_code: 'MA',
    },
    sales: [
      {
        id: 234110,
        asset_id: 1050,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 1,
        contract_type: 0,
        signature:
          '0x2a2cefa67944f647b32a84eed0dc2a861a358baa398948f4ee57431a4ef4f0e717f96f184cfb3264f525ad0a78abdef08ff5002e766e55b04ba8cba6aff72f281b',
        signature_hash: '0x880189b688f1c68d50dfa974179548fe6b62e889d552c4847cdee1397f640f30',
        tx_hash: '0x225ba3ec201960fdb820bc70e93965a0461a469ec3c1179faebe2e89f9c936e4',
        nonce: 33498,
        expiration_time: 1767567600,
        price: '1945000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234113,
        asset_id: 1050,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 3,
        contract_type: 0,
        signature:
          '0xab8dfbdf8816e03128b4fa7804e100faade8a1ba870d4d11aeb9c5f96144020f350973aad344761e19e5e2b57a65a12529a431aba7bde23aea3781fa3049c1801c',
        signature_hash: '0xbe1df15902da0281349ed778a84b06a9b8c6dd7e2fd5baadb7cedfdbcc5199da',
        tx_hash: null,
        nonce: 33499,
        expiration_time: 1767567600,
        price: '1945000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234116,
        asset_id: 1050,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 3,
        contract_type: 0,
        signature:
          '0x3de86c052f0b696825ccf2d4ca9e2fb8d9226bc0325bdd904fd932db6a8a89df644f7fb369cf3671bdb4b9ba88fce5954c514e8500ccbb72645d8bc3db8bd5ad1b',
        signature_hash: '0xdf37c9efc5f72bcfe24a669cd38c0d03a53f26bda7bedb23c32699351b43bbff',
        tx_hash: null,
        nonce: 33500,
        expiration_time: 1767567600,
        price: '1945000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234119,
        asset_id: 1050,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 3,
        contract_type: 0,
        signature:
          '0xe5b13d33697519b899350f92ea1a2e1005a83ed8744ddb214941286b4d008a1b136e9936624c808e3c6c7650997be04c58489e792bfe7132a0faf0e864a30da41c',
        signature_hash: '0x9b70b26745d3c40ce4822b260427384c5371ed23ad83e45c1dcd75eb934fc129',
        tx_hash: null,
        nonce: 33501,
        expiration_time: 1767567600,
        price: '1945000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234122,
        asset_id: 1050,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 3,
        contract_type: 0,
        signature:
          '0x9dd233d9d84399851009ef10a690f13144f2176478529a2c068e01381ec270937a3d23f541f20f69c56c3bb6dec3f890c87097e23df883002689a563425bd8471b',
        signature_hash: '0xd91c74926c307864b2cb0e7723630fb97bf37e910a9486b6b8fe6a541d8bd2c8',
        tx_hash: null,
        nonce: 33502,
        expiration_time: 1767567600,
        price: '1945000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234125,
        asset_id: 1050,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 3,
        contract_type: 0,
        signature:
          '0x57ba24059181e0d8b755e941ea7ffdc99261fec811ad078034d829664c40a4d92fa2a7e7a5a6130cbe574cc8477841d30dbe9df9cb6d3ad538ac141ea731ff811c',
        signature_hash: '0xed656f05933b30a4d8fc723790dc1886b7f42fcba4f21e0e728404f424ccac29',
        tx_hash: null,
        nonce: 33503,
        expiration_time: 1767567600,
        price: '9725000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234128,
        asset_id: 1050,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 3,
        contract_type: 0,
        signature:
          '0x3043410a677f50de20e6edbcdaab2a0960dc7ca91621eed7ec7935c28add44c9499b4a21514db79b299fee4720ed604ee66a70ef36d7a36d2691bbaf09b578d91b',
        signature_hash: '0xdceb43df7ab7417d0ac4111d17c8ae524b6c956f6cf4e86f3ef5fb21c8d8a8cb',
        tx_hash: null,
        nonce: 33504,
        expiration_time: 1767567600,
        price: '9725000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234131,
        asset_id: 1050,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 3,
        contract_type: 0,
        signature:
          '0x27297a015c436229d61537722203ec2ce290d6c4e3bfe81d7a182ad2571faf8f7994c102fa07ad0d701e4fbc0962c1e1539ffe4b713bc8958a7019755187ef8e1b',
        signature_hash: '0x9dda1166c55225def1a504a90b6e04e1a24397eb6317f5d8a47c044c9867dfb1',
        tx_hash: null,
        nonce: 33505,
        expiration_time: 1767567600,
        price: '9725000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234134,
        asset_id: 1050,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 3,
        contract_type: 0,
        signature:
          '0x7c0a8e6237fb49f7deee4b77672f6cfc6619ce435b41b26d69516f79929a87f75f897fe919701f1dc05c232de78b844b19a5f11eebb8c991948ffb9354e0b5a81b',
        signature_hash: '0x5ef28792dd6b2b4f56e2f49e3eb5ced9b1bb7140577a68825782fb49b83eb4cf',
        tx_hash: null,
        nonce: 33506,
        expiration_time: 1767567600,
        price: '19450000000000000000000',
        amount: '10',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234137,
        asset_id: 1050,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 3,
        contract_type: 0,
        signature:
          '0xc92427f6e2344b82a28a2e46770558d40c672fb1a5942f19e5bae6a73971482d1466f68cf62d8bdbb4a6199a08eb4bf1a6c9f6cab68861291fa3539e8585c0761b',
        signature_hash: '0xbe8b717a505e5b46e2fb77f2f9600f283edfafe80d34f96bb91ff5f7d0dcb128',
        tx_hash: null,
        nonce: 33507,
        expiration_time: 1767567600,
        price: '38900000000000000000000',
        amount: '20',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
    ],
    type: 'DAY',
    valid_from: 1767567600,
    valid_until: 1767654000,
    aggregated_sales: [
      {
        price: '1945000000000000000000',
        amount: '1',
        currency_id: 6,
        active_sales_ids: [],
        inactive_sales_ids: [234110, 234113, 234116, 234119, 234122],
      },
      {
        price: '9725000000000000000000',
        amount: '5',
        currency_id: 6,
        active_sales_ids: [],
        inactive_sales_ids: [234125, 234128, 234131],
      },
      {
        price: '19450000000000000000000',
        amount: '10',
        currency_id: 6,
        active_sales_ids: [],
        inactive_sales_ids: [234134],
      },
      {
        price: '38900000000000000000000',
        amount: '20',
        currency_id: 6,
        active_sales_ids: [],
        inactive_sales_ids: [234137],
      },
    ],
  },
  {
    asset: {
      name: 'Dublin',
      token_id: '592',
      id: 750,
      description: 'Dublin',
      country_code: 'IE',
    },
    sales: [
      {
        id: 234140,
        asset_id: 750,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x389c616069a563ce753f0a1ff45eb0e58bcec29e529207d70845c4b423a9f31439968974a4d0fad22e96ed28b06b554f2aa148175f00feb54aa18fb9c599fbbd1c',
        signature_hash: '0x5c469505f2fc2abdc4b7f2239beab066db3613f7d312e9fd7c19161aea3b685c',
        tx_hash: null,
        nonce: 33508,
        expiration_time: 1767654000,
        price: '2543000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234143,
        asset_id: 750,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x3ebff8a359a7e7b3bd94d8f8bdc944cfe90868371d7aaeef153a536ffbea49d31bcbcc2c73d4696bbc1538fe97d92506c0002f63849e0b40b947f380560c7d0a1b',
        signature_hash: '0x721143baf6c525660ec2f67ead74ebe7eff29a18aa04b17f29ee69317a4a0d8d',
        tx_hash: null,
        nonce: 33509,
        expiration_time: 1767654000,
        price: '2543000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234146,
        asset_id: 750,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x10160f051d84ee11dde5ae9c02e9a5dc527d2599fc2b6b9b62ac3750b9795661656c7753fd129afff2e7cdb44e0ee628388b779d382eafc064c043c3718cfb5d1b',
        signature_hash: '0x5f8df0b722457284a9242973b556ec9084849baf4ad304576a9e5c330c6dffe4',
        tx_hash: null,
        nonce: 33510,
        expiration_time: 1767654000,
        price: '2543000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234149,
        asset_id: 750,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x09fe5e8f18095d60db61c800c9e1945d623f43f231c5ec60979932c8bcd6f1b013d2b2f3cc2441417fc11fc7cd038bba04f927fa8be2ea0bd590794819d8515e1c',
        signature_hash: '0x89aa9d5159a3527dfd96a899b7b8b93d7436480c4b36f6aedaf25de3c4f66ab7',
        tx_hash: null,
        nonce: 33511,
        expiration_time: 1767654000,
        price: '2543000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234152,
        asset_id: 750,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x8877a00da8ac445576e680db973795b230fce84aa7a248805627c6e1cecd837f01eaf6a66a1880d391cff0b11ac0fa9fcec189d277649d6d12317695714d0dcb1b',
        signature_hash: '0x5bcffd87028a1ec0c3961c8eec3b535df92e4829c3b7b9b8af62f8b2ff53b359',
        tx_hash: null,
        nonce: 33512,
        expiration_time: 1767654000,
        price: '2543000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234155,
        asset_id: 750,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xbfb99d9cb94d67d7ce867df290083dbbd27fa5643328446dd454e954f13ffd613819656b8a851a55cbb138326f2dfef122740f3630681d89d47faa4ee53f17c01b',
        signature_hash: '0x411fa9d2d78fe4585dea8c9fd00975a0d20c995d447d8603d8fa2a18d1f92074',
        tx_hash: null,
        nonce: 33513,
        expiration_time: 1767654000,
        price: '12715000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234158,
        asset_id: 750,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x506c690343ac8c414882839f306a7f02ab4e877a193dea40ae4e0f0e45758b655362342814d9be52b8d7056479741ab46bb29af745b02aba311c226ca9cb49801c',
        signature_hash: '0xbe31c52e5ace1694ca9c0f5bdbdea1799eee2be48738427368a610b9da438b20',
        tx_hash: null,
        nonce: 33514,
        expiration_time: 1767654000,
        price: '12715000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234161,
        asset_id: 750,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xbfa257fbc2b7edd37fcbc45e6dbec2253a7b30612329de4c7b0ec5a41ab7f36750e53a0a48a32eccff3bea7dabc03cb6d36959e550d78c63195f43b211d20e231b',
        signature_hash: '0x6f53b19f5c84244a7f8157053a36e15ac721c8df020964f66666866ab8c06c03',
        tx_hash: null,
        nonce: 33515,
        expiration_time: 1767654000,
        price: '12715000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234164,
        asset_id: 750,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x378cd3df63738fff73f2f2d36926b6d4e3743f44f3c894c3881ec12a380ca3e2033c714fa61b66bedff83595287bbbc3dd8dab2b4d8a9f5fc2790a0f8e9197521b',
        signature_hash: '0x1c55865990bd1f85cd29a19822616407eaf2a29be597fcf2b8300db4fcef5e21',
        tx_hash: null,
        nonce: 33516,
        expiration_time: 1767654000,
        price: '25430000000000000000000',
        amount: '10',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234167,
        asset_id: 750,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xc2e73f659b6d8e83c2b41dbc7d0fc02920072db9fdae7f558a90f7b126e6d76e6abce9232dffcd2b40c7b7c85b8571bfcc1f8aeb0141f665ca6df3e60b6b03731c',
        signature_hash: '0xfc9aa9884605915fb23e9d1bba36452ae3f63a6a5bf6f2bf51b64fefdaaee97e',
        tx_hash: null,
        nonce: 33517,
        expiration_time: 1767654000,
        price: '50860000000000000000000',
        amount: '20',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
    ],
    type: 'DAY',
    valid_from: 1767654000,
    valid_until: 1767740400,
    aggregated_sales: [
      {
        price: '2543000000000000000000',
        amount: '1',
        currency_id: 6,
        active_sales_ids: [234140, 234143, 234146, 234149, 234152],
        inactive_sales_ids: [],
      },
      {
        price: '12715000000000000000000',
        amount: '5',
        currency_id: 6,
        active_sales_ids: [234155, 234158, 234161],
        inactive_sales_ids: [],
      },
      {
        price: '25430000000000000000000',
        amount: '10',
        currency_id: 6,
        active_sales_ids: [234164],
        inactive_sales_ids: [],
      },
      {
        price: '50860000000000000000000',
        amount: '20',
        currency_id: 6,
        active_sales_ids: [234167],
        inactive_sales_ids: [],
      },
    ],
  },
  {
    asset: {
      name: 'Minsk',
      token_id: '1247',
      id: 582,
      description: 'Minsk',
      country_code: 'BY',
    },
    sales: [
      {
        id: 234170,
        asset_id: 582,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x51e52011ecc025e4e595a22cdab901b9376b8c502e7f5506e17046929e60852d2a2827e120cb1cef713decf3990eb7cbec2593f0f7fdf45bbcaa6be106f7f5c31c',
        signature_hash: '0x07d969bb5226ebc22ccbf43cc05229c387e395783f586dba3f56d8a42dd69801',
        tx_hash: null,
        nonce: 33518,
        expiration_time: 1767740400,
        price: '2334000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234173,
        asset_id: 582,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xb2702d7d7945e0bc81b57a0487899346715c989113d5bc5b1b9b3a58307f684c034b71ec314bf7f9c7b18a76cf991f1353dd11ae5850fb163cc5c1c6ccc13fb61b',
        signature_hash: '0x6a76e42b9518e55f1b9717fbf533393d4a1c0c193e294b29c8ca43fef15d68db',
        tx_hash: null,
        nonce: 33519,
        expiration_time: 1767740400,
        price: '2334000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234176,
        asset_id: 582,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xe92280b1017401b0bb4d15fe14512405af77a5a48c1254c7f36aa7e097b6e955760e9297d07e99bc7df7fb8671b8f93bb3a39e030fb402aef31bfa0f424d9b2c1b',
        signature_hash: '0x20dfc9cdb0c8dbd0168d91d5bea35133076eb9e62bd6fb35c3ccfde1978e8c2e',
        tx_hash: null,
        nonce: 33520,
        expiration_time: 1767740400,
        price: '2334000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234179,
        asset_id: 582,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xca8c908c59cfcd54d4f936f4fe1d55b35f4953bd7dc083176050757f965f7cfd5e3932a75d1a2e1fdd290ecf06b8bef33990d4094d98833c6a15fe64e1c246bb1b',
        signature_hash: '0x2e40d55d69147b35c04c07f4ab016fbe714be3cc8a9eced377293424750f32d4',
        tx_hash: null,
        nonce: 33521,
        expiration_time: 1767740400,
        price: '2334000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234182,
        asset_id: 582,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xeee26e6f3dc6187e76594f61be15ed97b1b7bbe216d0dc9d8a8c6995e232752a6bdc40b718a31a8313573a084169c30db18286ea0e0e9d78e413964f2629dc0b1b',
        signature_hash: '0xafdc3d615baf40be10e5f132ee303499c855569960e2cc00db6da6d0d1aaf61f',
        tx_hash: null,
        nonce: 33522,
        expiration_time: 1767740400,
        price: '2334000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234185,
        asset_id: 582,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xa128f0566cf30de1316d6e1e62343abd4508e29ea286ad20c3be7da081d7738839f7a7b25989a660e34da7758303263f2b6e49053d29a70ec40cdb41c9c494121b',
        signature_hash: '0xcf36542fa5c1b29690b04e9f590ae9b5c56d50883ab33bcfbb0dc31f5ad2a5db',
        tx_hash: null,
        nonce: 33523,
        expiration_time: 1767740400,
        price: '11670000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234188,
        asset_id: 582,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x7b894d56cbdfda1830fa542f88498cce23d372be03fd9ecf36477e9b2a638b7d32109ec3abceb1120a052d23189de580da2ad66094a4f6561a638b09c88ff63b1c',
        signature_hash: '0x85117c03a6e9f7b05273b3c42d549c49ffa7fd2db509b973ebedece8c2c4abe1',
        tx_hash: null,
        nonce: 33524,
        expiration_time: 1767740400,
        price: '11670000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234191,
        asset_id: 582,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x5be9db5a833699a857dcae475a34437f1f2856cc28641482906f84a5a0315fbb5310b57370e7073ea38da871fc942f50d2ec5a309f7d952e70ea0158e94bef521c',
        signature_hash: '0x891c461bbfb705f34024673321cd5e65ce3f6965f59a81366701dc2eb6be8d8b',
        tx_hash: null,
        nonce: 33525,
        expiration_time: 1767740400,
        price: '11670000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234194,
        asset_id: 582,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xe15846138059ae13047cca67c01878ad1465eb37dccd626ce235a2c2b3a1bd952efdbbd9f55a4b6fb62ccdd39341ec8e7e319ed2a3aa8158dfff0ff83013d0a01b',
        signature_hash: '0x06281a6bf5c3b5962b2c0f32895c2d5bdb820503c1465a379f8a98053ba44fd0',
        tx_hash: null,
        nonce: 33526,
        expiration_time: 1767740400,
        price: '23340000000000000000000',
        amount: '10',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234197,
        asset_id: 582,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x1622604e72f82821dde112bed6f3d474d860bbb448d92b74460b453849110fe576abe46c50b4811999527673822ecebda4ba09c5947ab895c5f1c1e4a3512f951b',
        signature_hash: '0xe08ff1daf70bdacb62e8f7cc0e290bca4a9760d4cc1476748a3b060b834d24ca',
        tx_hash: null,
        nonce: 33527,
        expiration_time: 1767740400,
        price: '46680000000000000000000',
        amount: '20',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
    ],
    type: 'DAY',
    valid_from: 1767740400,
    valid_until: 1767826800,
    aggregated_sales: [
      {
        price: '2334000000000000000000',
        amount: '1',
        currency_id: 6,
        active_sales_ids: [234170, 234173, 234176, 234179, 234182],
        inactive_sales_ids: [],
      },
      {
        price: '11670000000000000000000',
        amount: '5',
        currency_id: 6,
        active_sales_ids: [234185, 234188, 234191],
        inactive_sales_ids: [],
      },
      {
        price: '23340000000000000000000',
        amount: '10',
        currency_id: 6,
        active_sales_ids: [234194],
        inactive_sales_ids: [],
      },
      {
        price: '46680000000000000000000',
        amount: '20',
        currency_id: 6,
        active_sales_ids: [234197],
        inactive_sales_ids: [],
      },
    ],
  },
  {
    asset: {
      name: 'Lincoln Memorial',
      token_id: '1103',
      id: 720,
      description: 'Lincoln Memorial',
      country_code: 'US',
    },
    sales: [
      {
        id: 234962,
        asset_id: 720,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xd2325fafab46f542e741845344e7697f57227d94e20d9dbb6f0ab2b4943645b5276e3331da2057395fe925dcf4f3c45d57611f54c06f5e98a44482aabe03e44e1b',
        signature_hash: '0xe86c898a9fdb30621c19a70f83691346da615854c53b5380e224c20fa4684e45',
        tx_hash: null,
        nonce: 33528,
        expiration_time: 1767826800,
        price: '3466000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234965,
        asset_id: 720,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xbdc7ac265989282dee0ae24c9d7e187840b1fdaa347ab3c564339c18001c23ee56f108a06694a93f79731bccb617234b55bb38303c6d4aef2ca66a2f5ca654161c',
        signature_hash: '0x90aed07a03f2fbe28be37ea33516fb379a176d06234cc4f8a5483ad094baa894',
        tx_hash: null,
        nonce: 33529,
        expiration_time: 1767826800,
        price: '3466000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234968,
        asset_id: 720,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xcc7f5802e316fce144619c6a3ef557512893d2f6f83a043ad3d00ee446ca8e4376164dcd6e38842b8b8f686e2cbd85fe7b997673ea82ef5a1a31cfbc1b1076571b',
        signature_hash: '0xd370eb57bc73538e7c13c6054ff2be60a57826c6a7cd0e338c09800bcabf6a9d',
        tx_hash: null,
        nonce: 33530,
        expiration_time: 1767826800,
        price: '3466000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234971,
        asset_id: 720,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x61c541e973de32c608a46cd5a93c1eb9eee071b301fb53a96c9575ad5c908bc32223caf46f63db73a91dfa863131bb775563faa47a40f58d3c1eb3e0957e22cd1c',
        signature_hash: '0xdb201de69990f3b1665c8c5281aa4da3a19c0a4cd8d7c77f2551d9866461287a',
        tx_hash: null,
        nonce: 33531,
        expiration_time: 1767826800,
        price: '3466000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234974,
        asset_id: 720,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x99b8e698ea5424054a0a8ef036cfaf9d4f2064073e4c9e765af17d74881688645126abcad315a9a9d80aa7591691e5a7d99d5d2075a14986967a7f3285b6d3161b',
        signature_hash: '0x6758adeedbb4f9fab4dc05f702dee8c65ecb092d1dc3d719a1a5a8b94f18a55b',
        tx_hash: null,
        nonce: 33532,
        expiration_time: 1767826800,
        price: '3466000000000000000000',
        amount: '1',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234977,
        asset_id: 720,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xcc7a0cc1360fb260d9a3fda742703a9e74c56b04c5dc870169f32bed475d928c098962e649e7b63824ebc978b0a79e0b96d71d8167427d57909c1385099a949f1c',
        signature_hash: '0x711304e017b526f8aa525fb748b261e0ec5c936263894161445d03467506c6e1',
        tx_hash: null,
        nonce: 33533,
        expiration_time: 1767826800,
        price: '17330000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234980,
        asset_id: 720,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xe6103d11130b8b184bf439b7a0c560b3c467326b0f144105c3ddd144a391ffb51c592194da3df58db2994d29b4e8a1c26fe9da398b9e42bf226b1fe1e2f6e91a1c',
        signature_hash: '0x01c09310d3d87a89a644e852d102c037d5593473542ebb038883b027adf80148',
        tx_hash: null,
        nonce: 33534,
        expiration_time: 1767826800,
        price: '17330000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234983,
        asset_id: 720,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xd0b6371b8ea4d9ed03fbbc6453da2eca11e2d44dce12ecf69202d3fbd7aea4650fac40b9bb9379e7ceb013b051dae65c3941292fa595dc4ee56da5be4ee78cce1b',
        signature_hash: '0xbad008bcc23d4602f21ccd521a42886c15a2e55b191625fdb692addaaf5b2f0d',
        tx_hash: null,
        nonce: 33535,
        expiration_time: 1767826800,
        price: '17330000000000000000000',
        amount: '5',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234986,
        asset_id: 720,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0xd9bfa262051d197e6fb5e67a693bc56e9185f4a18ecaae4228ab93e797cc885225d0a82d9e9632ae9d1afb80edfaefcf70297e20809c7d583e6070ee388f44981c',
        signature_hash: '0x624777aa91fbb865ead26bfacb1878a54bba1a6bc91b9435bbb59addfd67f5cf',
        tx_hash: null,
        nonce: 33536,
        expiration_time: 1767826800,
        price: '34660000000000000000000',
        amount: '10',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
      {
        id: 234989,
        asset_id: 720,
        seller: {
          id: 38067,
          address: '0x177569b5A83EEaE064fa0C2754EBAAf2987104ca',
          last_login: '2026-01-02T12:18:42.469020Z',
          date_joined: '2023-07-18T12:04:00Z',
        },
        type: 7,
        status: 0,
        contract_type: 0,
        signature:
          '0x91d6127a9b6a6dd3d33929f082053d8d5d959c4d1fc5d88dd1e2ad8e0b145f2b77d758af7d4a6926a0a699395dd5574d2e5fa60e0ba7556fc3550e348301eb541b',
        signature_hash: '0xccf8174c05389d3706a63126f8ac6e3416c41d4c00ec743e06619e06bb33b030',
        tx_hash: null,
        nonce: 33537,
        expiration_time: 1767826800,
        price: '69320000000000000000000',
        amount: '20',
        state_hash: '0x0',
        auction_id: null,
        stable_exchange_rate: null,
        currency_id: 6,
      },
    ],
    type: 'DAY',
    valid_from: 1767826800,
    valid_until: 1767913200,
    aggregated_sales: [
      {
        price: '3466000000000000000000',
        amount: '1',
        currency_id: 6,
        active_sales_ids: [234962, 234965, 234968, 234971, 234974],
        inactive_sales_ids: [],
      },
      {
        price: '17330000000000000000000',
        amount: '5',
        currency_id: 6,
        active_sales_ids: [234977, 234980, 234983],
        inactive_sales_ids: [],
      },
      {
        price: '34660000000000000000000',
        amount: '10',
        currency_id: 6,
        active_sales_ids: [234986],
        inactive_sales_ids: [],
      },
      {
        price: '69320000000000000000000',
        amount: '20',
        currency_id: 6,
        active_sales_ids: [234989],
        inactive_sales_ids: [],
      },
    ],
  },
];
